import { createClient } from '@supabase/supabase-js';
import { imageService } from './imageService';

const corsHeaders = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
  'Access-Control-Allow-Headers': 'Content-Type, Authorization',
};

export const hikerApi = {
  async getAccountInfo(username: string) {
    try {
      console.log(`🔍 Fetching account info for: ${username}`);
      
      const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/hiker-api`;
      const response = await fetch(`${apiUrl}?username=${encodeURIComponent(username)}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`❌ API Error Response: ${errorText}`);
        
        let errorMessage = 'Impossible de récupérer les infos du compte.';
        try {
          const errorData = JSON.parse(errorText);
          if (errorData.message) {
            errorMessage = errorData.message;
          }
        } catch (e) {
          console.error('Failed to parse error response:', e);
        }

        return { error: true, message: errorMessage };
      }

      const data = await response.json();
      console.log(`📦 API Response:`, data);

      if (data.error) {
        return {
          error: true,
          message: data.message || 'Impossible de récupérer les infos du compte.',
        };
      }

      // Get profile picture URL and upload to storage
      const profilePicUrl = data.profile_pic_url_hd || data.profile_pic_url || '';
      let imageUrl = await imageService.uploadAvatar(profilePicUrl, username);

      // If upload failed, try to get existing avatar from storage
      if (!imageUrl || imageUrl === 'https://via.placeholder.com/150') {
        const { data: existingAccount } = await supabase
          .from('instagram_accounts')
          .select('storage_avatar_url')
          .eq('username', username)
          .single();

        if (existingAccount?.storage_avatar_url) {
          imageUrl = existingAccount.storage_avatar_url;
        } else {
          imageUrl = await imageService.getPlaceholderUrl();
        }
      }

      return {
        error: false,
        data: {
          username: data.username,
          fullName: data.full_name,
          followers: data.follower_count?.toString() || '0',
          following: data.following_count?.toString() || '0',
          posts: data.media_count || 0,
          isPrivate: data.is_private,
          isVerified: data.is_verified,
          profilePicUrl: imageUrl,
          biography: data.biography,
          externalUrl: data.external_url,
          isBusiness: data.is_business,
          businessCategory: data.business_category_name || data.category_name,
          businessEmail: data.public_email,
          businessPhone: data.contact_phone_number,
          address: data.address_street,
          city: data.city_name,
          locationLat: data.latitude,
          locationLng: data.longitude,
          locationZip: data.zip
        },
      };
    } catch (err) {
      console.error('❌ Connection error:', err);
      return { 
        error: true, 
        message: 'Erreur de connexion au serveur.',
        details: err.message 
      };
    }
  },
};